module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"roles":"Rollen","edit_all":"Alle bearbeiten","zr_number":"ZR-Nummer"},"en":{"roles":"Roles","edit_all":"Edit all","zr_number":"ZR number"},"nl":{"roles":"Rollen","edit_all":"Alles bewerken","zr_number":"Zrnummer"}}')
  delete Component.options._Ctor
}
